import styled from '@emotion/styled';

export const DivWrapper = styled.section<{
  bgColor: string;
  isClickable?: boolean;
}>`
  display: flex;
  justify-content: center;
  background: ${({ bgColor }) => (bgColor ? bgColor : 'white')};
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
`;
